export function allLiveAuctionListReducer(
  state = {
    allLiveAuctionListData: [],
    ListLoadings: false,
    liveBidingHistory: {},
    loading: false,
    loadingId: "",
    bidUpdateData: {},
    autoBidCancelData: {},
    paidEmdLoading: false,
    paidEmdOfferData: {},
    payEmdInLiveLoading: false,
  },
  { type, payload, loadingId }
) {
  switch (type) {
    case "SHOW_LIVE_AUCTION_LIST":
      return { ...state, ListLoadings: true };
    case "FETCH_LIVE_AUCTION_LIST":
      return { ...state, allLiveAuctionListData: payload, ListLoadings: false };
    case "CANNOT_FETCH_LIVE_AUCTION_LIST":
      return { ...state, ListLoadings: true };
    case "LIVE_ROOM_HISTORY_FETCHING":
      return { ...state, ListLoadings: true };
    case "LIVE_ROOM_HISTORY_SUCCESS":
      return { ...state, liveBidingHistory: payload, ListLoadings: false };
    case "CANNOT_LIVE_ROOM_HISTORY":
      return { ...state, ListLoadings: false };
    case "LIVE_ROOM_DATA_FETCHING":
      return { ...state, loading: true, loadingId: loadingId };
    case "LIVE_ROOM_DATA_SUCCESS":
      return { ...state, loading: false, bidUpdateData: payload };
    case "CANCEL_AUTO_BID_SUCCESS":
      return { ...state, loading: false, autoBidCancelData: payload };
    case "CANNOT_LIVE_ROOM_DATA":
      return { ...state, loading: false };
    case "LIVE_PAID_OFFER_LOADING":
      return { ...state, paidEmdLoading: true };
    case "LIVE_PAID_OFFER_SUCCESS":
      return { ...state, paidEmdLoading: false, paidEmdOfferData: payload };
    case "LIVE_PAID_OFFER_FAILED":
      return { ...state, paidEmdLoading: false, paidEmdOfferData: {} };
    case "SHOW_LIVE_PAY_EMD":
      return { ...state, payEmdInLiveLoading: true, };
    case "SUCCESS_LIVE_PAY_EMD":
      return { ...state, payEmdInLiveLoading: false, };
    case "FAILED_LIVE_PAY_EMD":
      return { ...state, payEmdInLiveLoading: false, };



    default:
      return state;
  }
}

export function allSellerLiveAuctionReducer(
  state = {
    allSellerLiveAuctionData: [],
    sellerLiveBidingHistory: [],
    sellerLoading: false,
    liveBidderSellerHistry: {}
  },
  { type, payload }
) {
  switch (type) {
    case "SHOW_LIVE_AUCTION_SELLER":
      return { ...state, sellerLoading: true };
    case "SUCCESS_LIVE_AUCTION_SELLER":
      return { ...state, allSellerLiveAuctionData: payload, sellerLoading: false };
    case "LIVE_ROOM_SELLER_HISTORY_SUCCESS":
      return { ...state, sellerLiveBidingHistory: payload, sellerLoading: false };
    case "CANNOT_FETCH_LIVE_AUCTION_SELLER":
      return { ...state, sellerLoading: false };
    case "LIVE_AUCTION_HISTORY_SUCCESS":
      return { ...state, sellerLoading: false, liveBidderSellerHistry: payload };
    default:
      return state;
  }
}

export function singleAuctionIndustryReducer(
  state = {
    sellerLoading: false,
    industrySingleAuction: {}
  },
  { type, payload }
) {
  switch (type) {
     case "READ_SINGLE_LIVE_SELLER_LOADING":
      return { ...state, sellerLoading: true, };
    case "READ_SINGLE_LIVE_SELLER_SUCCESS":
      return { ...state, sellerLoading: false,industrySingleAuction: payload, };
    case "READ_SINGLE_LIVE_SELLER_FAILED":
      return { ...state, sellerLoading: false, };
    default:
      return state;
  }
}

